import { IS_ETS_NEXT } from '@/utils/constants';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import React, { useState } from 'react';

function ObscuredInput(props) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <TextField
      {...props}
      {...(IS_ETS_NEXT ? { autoComplete: 'off' } : {})}
      type={showPassword ? 'text' : 'password'}
      InputProps={{
        ...props.InputProps,
        endAdornment: (
          <InputAdornment position='end'>
            <IconButton
              aria-label='toggle password visibility'
              onClick={() => setShowPassword((show) => !show)}
              edge='end'
              tabIndex={-1}
              sx={{ color: '#4f7cf7' }}
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}

export default ObscuredInput;
